export default "__VITE_ASSET__cbc15f5f__"